import { postPushNotificationsApiHeaders } from '@module/mdrt-org/shared/utils/helpers/get-headers';
import { mutateWithErrorHandling } from '@module/mdrt-org/shared/utils/http-services/mutate-with-error-handling';

export const deleteWebPushSubscription = async ({
  accessToken,
  auth,
  deviceId,
  endpoint,
  p256dh,
  personId,
}: {
  accessToken: string | undefined;
  auth?: string;
  deviceId?: string;
  endpoint?: string;
  p256dh?: string;
  personId: number | undefined;
}) => {
  if (!(accessToken && personId)) {
    throw new Error('Access token or person ID is not available');
  }

  const url = `${window.PUBLIC_ENV.apiBaseUrl}/${
    window.PUBLIC_ENV.notificationsApiRoute ?? 'notifications-api'
  }/Notifications/Users/${personId}/WebPush`;

  await mutateWithErrorHandling(url, {
    body: JSON.stringify({ auth, deviceId, endpoint, p256dh }),
    headers: {
      ...postPushNotificationsApiHeaders(accessToken),
      'Content-Type': 'application/json',
    },
    method: 'DELETE',
  });

  return null;
};
